import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  availabilityIcon: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(-1),
    verticalAlign: 'middle',
  },
  statusIcon: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(-1),
    verticalAlign: 'middle',
  },
  verified: {
    verticalAlign: 'middle',
    animation: 'name-type-appear 0.5s ease-out 0.55s',
    animationFillMode: 'backwards',
    color: 'rgb(0, 165, 0)',
  },
  unverified: {
    verticalAlign: 'middle',
    animation: 'name-type-appear 0.5s ease-out 0.55s',
    animationFillMode: 'backwards',
    color: 'rgba(0, 0, 0, 0.4)',
  },
}))
